import * as React from "react";
import styled from "styled-components";

import {
  IconDate,
  IconLocation,
  IconLock,
  IconTreatments,
  IconX,
  Image,
  NavItem,
  Text,
} from "../../../../components/atoms";
import { theme } from "../../../../theme";

interface IProps {
  avatar?: string;
  className?: string;
  clearState?(): void;
  icon?: "avatar" | "date" | "location" | "treatments" | "booking";
  label?: string;
  link?: string;
  state?: boolean;
  title?: string;
}

const BreadcrumbSection = styled.div`
  display: inline-flex;
  flex-direction: column;
  vertical-align: middle;
`;

const BreadcrumbSectionIcon = BreadcrumbSection.extend`
  margin-right: 16px;
  align-self: center;

  @media screen and (max-width: 992px) {
    display: none;
  }
`;

const BreadcrumbRemoveIcon = styled.div`
  display: flex;
  position: absolute;
  top: 2px;
  right: 8px;
  cursor: pointer;

  > svg {
    width: 14px;
    height: 14px;
    fill: ${theme.color.borderColor};
    transition: fill ${theme.transition.linear03};

    &:hover {
      fill: ${theme.color.ruubyBlack};
    }
  }
`;

const BreadcrumbAvatar = Image.extend`
  width: 32px;
  height: 32px;
  border: 1px solid ${theme.color.borderColor};
`;

const BreadcrumbNavItem = styled(NavItem)`
  font-size: ${theme.fontSize.main};
  align-self: center;

  @media screen and (max-width: 992px) {
    font-size: ${theme.fontSize.smaller};
    text-align: center;
  }
`;

const BreadcrumbIconLock = styled.div`
  > svg {
    fill: ${theme.color.iconColor};
  }
`;

const BreadcrumbItem = styled.div`
  display: flex;
  align-self: center;

  ${Text} {
    text-transform: capitalize;
  }
`;

const BreadcrumbLabelText = styled(Text)`
  @media screen and (max-width: 992px) {
    font-weight: 600;
  }
`;

const BreadcrumbWrapper = styled.div`
  display: flex;
  position: relative;
  height: 100%;
  min-width: 185px;
  padding: 0 32px;
  border-right: 1px solid ${theme.color.borderColorGrey};
  box-sizing: content-box;

  @media screen and (max-width: 992px) {
    min-width: auto;
    padding: 0px 14px;
  }
`;

const Breadcrumb: React.FC<IProps> = (props) => {
  const iconSelector = {
    avatar: props.avatar && <BreadcrumbAvatar src={props.avatar} rounded />,
    booking: (
      <BreadcrumbIconLock>
        <IconLock />
      </BreadcrumbIconLock>
    ),
    date: <IconDate />,
    location: <IconLocation />,
    treatments: <IconTreatments />,
  };

  return (
    <BreadcrumbWrapper>
      <BreadcrumbItem>
        {props.icon && (
          <BreadcrumbSectionIcon>
            {iconSelector[props.icon]}
          </BreadcrumbSectionIcon>
        )}
        <BreadcrumbSection>
          {props.link ? (
            <BreadcrumbNavItem to={props.link} activeClassName="none">
              {props.title}
            </BreadcrumbNavItem>
          ) : (
            <Text weight="semibold" mobileSize="12">
              {props.title}
            </Text>
          )}
          {props.label ? (
            <BreadcrumbLabelText size="12">{props.label}</BreadcrumbLabelText>
          ) : (
            ""
          )}
        </BreadcrumbSection>
      </BreadcrumbItem>
      {props.state && (
        <BreadcrumbRemoveIcon onClick={props.clearState}>
          <IconX />
        </BreadcrumbRemoveIcon>
      )}
    </BreadcrumbWrapper>
  );
};

export { Breadcrumb };
